'use client';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import HeaderVariety from '@primitives/HeaderVariety';
import SocialLinks from '@repo/ui/src/components/SocialLinks';
import Image from '@repo/ui/src/components/Image/New';
import { classNames } from '@repo/ui/src/utils/classNames';

const BioHeaderCard = ({
  image,
  photoPosition,
  title,
  description,
  facebookLink,
  instagramLink,
  twitterLink,
  youtubeLink,
  websiteLink,
  overLappingPrevComponent,
  headerVariation,
}) => {
  return (
    <section data-testid="bio_header_card">
      <Image
        src={buildImageSrc(image, 960, 4, 1)}
        alt={image?.name}
        width={0}
        height={400}
        sizes="100vw"
        className="flex md:hidden object-cover h-[400px] w-full"
      />
      <div
        className={classNames(
          'max-w-[960px] lg:max-w-[1140px] mx-auto px-2 sm:px-4',
          overLappingPrevComponent && 'md:relative md:top-[-50px] md:z-[100]',
        )}
      >
        <div className=" md:mx-5 bg-white relative top-[-50px] md:top-0">
          <div
            className={classNames(
              'flex flex-col md:items-stretch',
              photoPosition === 'photo-right' ? 'md:flex-row-reverse' : 'md:flex-row',
            )}
          >
            <div className="md:flex-[4] lg:flex-[3]">
              <Image
                src={buildImageSrc(image, 350, 4, 5)}
                alt={image?.name}
                className="hidden object-cover h-full max-w-full md:flex object-fit"
                height={440}
                width={350}
              />
            </div>

            <div
              className={classNames(
                'md:flex-[8] lg:flex-[9] p-3 sm:p-5 md:p-4 lg:p-10 border-warm-200 border text-center border-t md:text-left md:border-b',
              )}
            >
              <div className="mt-1 mb-3">
                <HeaderVariety
                  defaultVariation="h3"
                  headerVariation={headerVariation?.headerVariation}
                >
                  {title}
                </HeaderVariety>
              </div>
              <p className="mb-4 text-body2 md:mb-5">{description}</p>
              <div className={classNames('flex justify-center md:justify-start')}>
                <SocialLinks
                  facebook={facebookLink}
                  instagram={instagramLink}
                  twitter={twitterLink}
                  youtube={youtubeLink}
                  website={websiteLink}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BioHeaderCard;
